import { setCookie } from 'common/utils/cookies'

export const setPreviousOriginCookie = (geocoderResult) => {
  setCookie('previousOrigin', geocoderResult.serialize(), 1000)
}

export const setPreviousDestinationCookie = (geocoderResult) => {
  setCookie('previousDestination', geocoderResult.serialize(), 1000)
}

export const setPreviousTicketOriginCookie = (geocoderResult) => {
  setCookie('previousTicketOrigin', geocoderResult.serialize(), 1000)
}

export const setPreviousTicketDestinationCookie = (geocoderResult) => {
  setCookie('previousTicketDestination', geocoderResult.serialize(), 1000)
}

export const setPreviousOriginCookieFromLongName = (geocoderResult) => {
  setPreviousLocationCookieFromLongName(geocoderResult, true, false)
}

export const setPreviousDestinationCookieFromLongName = (geocoderResult) => {
  setPreviousLocationCookieFromLongName(geocoderResult, false, false)
}

export const setPreviousTicketOriginCookieFromLongName = (geocoderResult) => {
  setPreviousLocationCookieFromLongName(geocoderResult, true, true)
}

export const setPreviousTicketDestinationCookieFromLongName = (geocoderResult) => {
  setPreviousLocationCookieFromLongName(geocoderResult, false, true)
}

const setPreviousLocationCookieFromLongName = (geocoderResult, isOrigin, isTicket) => {
  if (!geocoderResult || geocoderResult.isSpecial()) {
    // don't do anything
    return
  }

  if (isTicket) {
    if (isOrigin) {
      setPreviousTicketOriginCookie(geocoderResult)
    } else {
      setPreviousTicketDestinationCookie(geocoderResult)
    }
  } else {
    if (isOrigin) {
      setPreviousOriginCookie(geocoderResult)
    } else {
      setPreviousDestinationCookie(geocoderResult)
    }
  }
}
